import styled from 'styled-components/macro';
import * as DropDownMenu from '@radix-ui/react-dropdown-menu';

export const Wrapper = styled(DropDownMenu.Arrow)`
  fill: ${({ theme }) => theme.colors.gray[6]};
  width: 18px;
  height: 9px;
  margin: 0 16px;
`;
